<script lang="ts" setup>
import { useService } from '@kaokei/use-vue-service';
import { AudioActionService } from './AudioAction.service';

const audioActionService = useService(AudioActionService);
</script>

<template>
  <a-button
    :disabled="false"
    class="!flex !h-[30px] !p-0 flex-center"
    type="ghost"
    @click="audioActionService.visible = true"
    ><img
      class="w-4"
      src="@core/assets/image/im/icon-mic.svg"
      alt=""
    />发送语音</a-button
  >
</template>
